import { A } from "@solidjs/router";
import type { Category } from "@talkers/shared";
import { For, type JSX, Show } from "solid-js";
import { absoluteTime, relativeTime } from "@/lib/time";

/** カテゴリツリー。階層は 3 段程度を想定して素朴に再帰で描く。 */
export function CategoryTree(props: { categories: Category[] }): JSX.Element {
  return (
    <ul class="cat-tree">
      <For each={props.categories}>
        {(category) => (
          <li>
            <A
              href={`/c/${category.slug}`}
              class="cat-link"
              classList={{ "cat-link--hidden": category.isHidden }}
              activeClass="cat-link--active"
              end
            >
              <span class="cat-name">{category.name}</span>
              <Show when={category.lastPostAt}>
                {(at) => (
                  <time class="cat-time" datetime={at()} title={absoluteTime(at())}>
                    {relativeTime(at())}
                  </time>
                )}
              </Show>
              <Show when={category.threadCount > 0}>
                <span class="cat-count">{category.threadCount}</span>
              </Show>
            </A>
            <Show when={category.children.length > 0}>
              <CategoryTree categories={category.children} />
            </Show>
          </li>
        )}
      </For>
    </ul>
  );
}
